import * as $ from "jquery";
import { $messageHover } from "../common/message";

let isHover = false;
let dt: any = null;
let component: any = null;
let scrollTop = 0;
let scrollLeft = 0;

function postHover(): void {
  const rect = component.getBoundingClientRect() || {};
  const json = {
    isShow: 1,
    scrollTop: scrollTop,
    scrollLeft: scrollLeft,
    componentId: component.dataset.componentId,
    top: rect.top < 0 ? 0 : rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
    x: rect.x,
    y: rect.y,
  };
  $messageHover(json);
}

export function componentHover(): void {
  $(document)
    .off(".component-hover")
    .on("mouseenter.component-hover", ".sk-component", function () {
      isHover = true;
      component = this;
      try {
        if (component.className.indexOf("SIDEBAR") > -1) {
          return;
        }
      } catch (e) {
        console.log(e);
      }
      postHover();
    })
    .on("mouseleave.component-hover", () => {
      isHover = false;
      component = null;
      clearTimeout(dt);
      dt = setTimeout(() => {
        if (!isHover) {
          $messageHover({
            isShow: 0,
            top: 0,
            left: 0,
            scrollTop: 0,
            scrollLeft: 0,
          });
        }
      }, 300);
    });
}

$(window)
  .off(".stemplate-hover")
  .on("scroll.stemplate-hover", () => {
    scrollTop = $(document).scrollTop();
    scrollLeft = $(document).scrollLeft();
    if (component) {
      postHover();
    }
  });
